import Thunk from 'redux-thunk'
import Axios from 'axios'

import AT from "./actionTypes"
import {showLoading, hideLoading} from 'react-redux-loading-bar'
import {url} from '../lib/kvs'


// roxby: handle errors in all async actions (by redirecting to _error?)


/**
 * @param backpage - {route, params}
 * @param componentClass
 * @param componentParams - object | null
 * @returns {{backpage: *, video: (null|*), type: string}}
 */
export const modalOpen = (backpage, componentClass = null, componentParams = null) => {
    return {
        type: AT.MODAL_OPEN,
        componentClass,
        componentParams,
        backpage
    }
}

export const modalClose = () => {
    return {
        type: AT.MODAL_CLOSE
    }
}


/**
 * @param desc - optional description for debug purposes
 * @returns {{}}
 */
export const ajaxStarted = (desc = '') => {
    return showLoading()
}

/**
 * @param success - boolean result
 * @returns {{}}
 */
export const ajaxFinished = (success) => {
    return hideLoading()
}

/**
 * @param params HTTP request params
 * @param dest sidebar|page - destination where the data is fetched for
 * @returns {function(*): Promise<AxiosResponse<any>>}
 */
export const categoriesFetch = (params, dest) => {
    return (dispatch) => {
        dispatch(ajaxStarted(`going to fetch categories for ${dest}`))
        return Axios.get(url('categories'), {params}).then(function (response) {
            dispatch(categoriesReceived(response.data, dest))
            dispatch(ajaxFinished(true))
        })
    }
}

export const categoriesReceived = ({data, total}, dest) => {
    return {
        type: AT.CATEGORIES_RECEIVED,
        data,
        total,
        dest
    }
}

export const categoryFetch = (slug, params) => {
    return (dispatch) => {
        dispatch(ajaxStarted(`going to fetch category ${slug}`))
        return Axios.get(url(`categories/${slug}`), {params}).then(function (response) {
            dispatch(categoryReceived(response.data))
            dispatch(ajaxFinished(true))
        })
    }
}

export const categoryReceived = (category) => {
    return {
        type: AT.CATEGORY_RECEIVED,
        ...category
    }
}

export const videosFetch = (page, section, params) => {
    return (dispatch) => {
        dispatch(ajaxStarted(`fetching videos for ${page}, ${section}`))
        return Axios.get(url('videos'), {params}).then(function (response) {
            dispatch(videosReceived(page, section, response.data))
            dispatch(ajaxFinished(true))
        })
    }
}

export const videosReceived = (page, section, {data, total}) => {
    return {
        type: AT.VIDEOS_RECEIVED,
        page,
        section,
        data,
        total
    }
}

export const videoFetch = (id, params = {}) => {
    return function (dispatch) {
        dispatch(ajaxStarted(`loading video ${id}`))
        return Axios.get(url(`videos/${id}`), {params}).then(function (response) {
            dispatch(videoReceived(response.data))
            dispatch(ajaxFinished(true))
        })
    }
}

export const videoView = (id) => {
    return function (dispatch) {
        return Axios.post(url(`videos/${id}/view`)).then(function (success) {
            return {
                type: AT.VIDEO_VIEW,
                success
            }
        })
    }

}

export const videoReceived = (video) => {
    return {
        type: AT.VIDEO_RECEIVED,
        video,
    }
}

export const modelsReceived = (models, dest) => {
    return {
        type: AT.MODELS_RECEIVED,
        models,
        dest
    }
}

/**
 * @param params HTTP request params
 * @param dest index|models - destination where the data is fetched for
 * @returns {function(*): Promise<AxiosResponse<any>>}
 */
export const modelsFetch = (params, dest) => {
    return (dispatch) => {
        dispatch(ajaxStarted(`fetching models`))
        return Axios.get(url('models'), {params}).then(function (response) {
            dispatch(modelsReceived(response.data, dest))
            dispatch(ajaxFinished(true))
        })
    }
}

export const modelFetch = (slug, params) => {
    return function (dispatch) {
        dispatch(ajaxStarted(`fetching model ${slug}`))
        return Axios.get(url(`models/${slug}`), {params}).then(function (response) {
            dispatch(modelReceived(response.data))
            dispatch(ajaxFinished(true))
        })
    }
}

export const modelReceived = (model) => {
    return {
        type: AT.MODEL_RECEIVED,
        ...model
    }
}

export const modelRate = (id, params) => {
    return function (dispatch) {
        dispatch(ajaxStarted(`rating model ${id}`))
        return Axios.post(url(`models/${id}/rate`), params).then(function (response) {
            dispatch(modelRated(response.data))
            dispatch(ajaxFinished(true))
        })
    }
}

export const modelRated = (data) => {
    return {
        type: AT.MODEL_RATED,
        ...data
    }
}


export const searchFetch = (params) => {
    const query = params.q;
    return (dispatch) => {
        dispatch(ajaxStarted(`searching for ${query} videos`))
        return Axios.get(url('search'), {params}).then(function (response) {
            dispatch(searchReceived(response.data, query))
            dispatch(ajaxFinished(true))
        })
    }
}

export const searchReceived = ({data, total, related}, query) => {
    return {
        type: AT.SEARCH_RECEIVED,
        data,
        total,
        related,
        query
    }
}

export const relatedSearchesFetch = (params) => {
    return (dispatch) => {
        dispatch(ajaxStarted(`searching reated: ${params.query}`))
        return Axios.get(url('related-searches'), {params}).then(function (response) {
            dispatch(relatedSearchesReceived(response.data))
            dispatch(ajaxFinished(true))
        })
    };
}

export const relatedSearchesReceived = (data, query) => {
    return {
        type: AT.RELATED_SEARCHED_RECEIVED,
        data
    }
};


export const mobileMenuOpen = () => {
    return {
        type: AT.MOBILE_MENU_OPEN
    }
}

export const mobileMenuClose = () => {
    return {
        type: AT.MOBILE_MENU_CLOSE
    }
}



// WEBPACK FOOTER //
// redux/actions.js